// @ts-nocheck
import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { ACCESS_CONTROL_PROPS, ACCESS_LEVEL_DOCS } from '../../support/accessControlConstants';
import Button from '../core/Button';
import HoverButton, { HOVER_BUTTON_PROPS } from '../core/HoverButton';
import Link from '../core/Link';
import AccessControlWrapper from './AccessControlWrapper';
import { ACCESS_COMPONENT_DEFAULT_PROPS } from './ts/AccessControl.constants';
type InnerButtonProps = {
  accessDenied: boolean;
  i13nModel: Record<string, any>;
  hideOnAccessDenied?: boolean;
};

class AccessInnerButton extends PureComponent<InnerButtonProps> {
  render() {
    // If enabled, we want to show a regular button or hover depending on what props are passed in
    if (!this.props.accessDenied) {
      const isHover = Object.keys(this.props).some((p) => HOVER_BUTTON_PROPS.includes(p));
      return isHover ? <HoverButton {...this.props} /> : <Button {...this.props} />;
    }

    if (this.props.accessDenied && this.props.hideOnAccessDenied) {
      return null;
    }

    // If disabled due to access control, we want to show a tooltip on hover
    const i13nModel = { ...this.props.i13nModel };
    i13nModel.params = R.merge(
      {
        access_controlled: true,
      },
      i13nModel.params
    );
    return (
      <HoverButton
        {...this.props}
        i13nModel={i13nModel}
        componentShownOnHover={
          <span>
            You{' '}
            <Link href={ACCESS_LEVEL_DOCS} testid="access-denied__button-link">
              don't have access
            </Link>{' '}
            to this feature.
          </span>
        }
      />
    );
  }
}

type Props = {
  accessResources?: Array<string>;
  permission?: number;
  onClick?: (event: React.SyntheticEvent<any>) => void;
  id?: string;
  newTab?: boolean;
  className?: string;
  to?: string;
  type?: string;
  testid?: string;
  loading?: boolean;
  size?: string;
  activeChild?: React.JSX.Element | null;
  componentShownOnHover?: React.JSX.Element;
  showOnAccessDenied?: React.JSX.Element;
  position?: string;
  disabled?: boolean;
  i13nLabel?: string;
  i13nModel?: Record<string, any>;
  hideOnAccessDenied?: boolean;
  children: any;
};
export default class AccessButton extends PureComponent<Props> {
  // TODO: I don't even know what's going on here!
  // As soon as this component is imported by any file in common/components/core
  // all properties from support/accessControl seems to get blown away
  // I'm using this to merge in the default props as a workaround
  // Is this a webpack issue? some other bundling issue?
  static defaultProps = ACCESS_COMPONENT_DEFAULT_PROPS;

  render() {
    const { accessResources, permission } = this.props;
    return (
      <AccessControlWrapper accessResources={accessResources} permission={permission} accessDeniedPropName="accessDenied">
        <AccessInnerButton {...R.omit(ACCESS_CONTROL_PROPS, this.props)} />
      </AccessControlWrapper>
    );
  }
}
